import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { UserRoles } from '@app/shared/enums/UserRoles.enum';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, Observable, of } from 'rxjs';
import { RolesService } from '../backend/clients';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {

  constructor(public translate: TranslateService, public rolesService: RolesService) { 

  }

  async transform(userRole: any) {
    if (userRole?.length === 0) {
      return of(this.translate.instant('ENUMS.NO_ROLES'));
    }

    return userRole ?? this.translate.instant('ENUMS.NO_ROLES');
  }

}
